import { authorizeGetRequest, authorizePostRequest } from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import {
  ICasherDriverIncomeResponse,
  ICasherDriversResponse,
  ICasherGrossResponse,
  ICasherNetResponse,
  ICasherPassengersResponse,
  ICasherTaxResponse,
  ICompleteBookingCarpoolingInput,
  IDriversWalletBalanceResponse,
  IDriverUsedWalletResponse,
  IFinanceResponse,
  INetChartResponse,
  ITotalIncomeResponse,
  ITripDetailResponse,
  ITripsModel,
  ITripStatisticsResponse,
} from "models/trips";
import { IFinanceFilter } from "pages/FinanceAccountDashboard";

export const tripModelsApi = (
  page: number,
  perPage: number,
  search: string,
  status?: string,
  date?: string,
  useCache: boolean = false
) => {
  search = search.replace("+", "%2B");
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("per_page", perPage.toString());
  if (search) params.append("search", search);
  if (status) params.append("status", status);
  if (date) params.append("date", date);
  return authorizeGetRequest<IPaginatedResponse<ITripsModel>>(
    `trips?${params.toString()}`,
    useCache
  );
};

export const financeApi = (useCache: boolean = false) => {
  return authorizeGetRequest<IFinanceResponse>(`trips/finance`, useCache);
};

export const fetchTripByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<ITripDetailResponse>>(`trips/${id}`);
};

export const fetchTripByIdWithLocationApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<ITripDetailResponse>>(
    `trips/${id}/location/detail`
  );
};

export const fetchTripByIdWithGooglePathApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<ITripDetailResponse>>(
    `trips/${id}/google-path/detail`
  );
};

export const fetchTripEstimationByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<ITripDetailResponse>>(
    `trips/${id}/estimation`
  );
};

export const fetchTripStatisticsApi = (useCache: boolean = false) => {
  return authorizeGetRequest<ITripStatisticsResponse>(`trips/statistics`, useCache);
};

export const cancelTripByIdApi = (id: string) => {
  return authorizePostRequest<ITripDetailResponse>(
    `trips/${id}/cancel/admin`,
    {}
  );
};
export const completeTripByIdApi = (id: string) => {
  return authorizePostRequest<IApiResponse<ITripDetailResponse>>(
    `trips/${id}/complete/admin`,
    {}
  );
};

export const tripsTotalIncomeApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<ITotalIncomeResponse>(
    `trips/casher/total-income?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsCasherGrossApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<ICasherGrossResponse>(
    `trips/casher/gross?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsCasherNetApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<ICasherNetResponse>(
    `trips/casher/net?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsCasherTaxApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<ICasherTaxResponse>(
    `trips/casher/tax?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsCasherDriverIncomeApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<ICasherDriverIncomeResponse>(
    `trips/casher/driver-income?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsCasherTotalDriversApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<ICasherDriversResponse>(
    `trips/casher/total-drivers?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsCasherTotalPassengersApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<ICasherPassengersResponse>(
    `trips/casher/total-passengers?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsDriversWalletBalanceApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<IDriversWalletBalanceResponse>(
    `trips/casher/driver-wallet-balance?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsDriverUsedWalletApi = (filterType: IFinanceFilter, useCache: boolean = false) => {
  return authorizeGetRequest<IDriverUsedWalletResponse>(
    `trips/casher/driver-used-wallet?filter_type=${filterType.toLocaleLowerCase()}`,
    useCache
  );
};

export const tripsCasherNetChartApi = (year: string, useCache: boolean = false) => {
  return authorizeGetRequest<INetChartResponse>(
    `trips/casher/net-chart?year=${year}`,
    useCache
  );
};
export const carpoolingApi = (
  page: number,
  perPage: number,
  search: string
) => {
  search = search.replace("+", "%2B");
  return authorizeGetRequest<IPaginatedResponse<ITripsModel>>(
    `trips/carpooling?page=${page}&per_page=${perPage}&search=${search}`
  );
};

export const cancelCarpoolingTripByIdApi = (id: string) => {
  return authorizePostRequest<ITripDetailResponse>(
    `trips/carpooling/${id}/cancel/admin`,
    {}
  );
};

export const completeCarpoolingTripByIdApi = (id: string) => {
  return authorizePostRequest<ITripDetailResponse>(
    `trips/carpooling/${id}/complete/admin`,
    {}
  );
};

export const completeBookingCarpoolingTripByIdApi = ({
  booking_id,
  id,
}: ICompleteBookingCarpoolingInput) => {
  return authorizePostRequest<ITripDetailResponse>(
    `trips/carpooling/${id}/booking/complete/admin`,
    { booking_id }
  );
};
